module.exports = __webpack_public_path__ + "static/water_elemental_myrmidon-f38b4339af2e5c28c2f1193923110892.png";